<span
  [ngClass]="
    bgClass +
    ' text-primary px-8 py-4 border-radius-2 font-medium fs-15 text-uppercase flex ion-align-items-center ion-justify-content-center'
  "
>
  <ng-content></ng-content>
</span>
